// Every refusal the API can send back on the callback route, in words a person
// can act on. The underlying reason stays in the server log.
export const SSO_ERROR_MESSAGES = {
    SSO_NOT_CONFIGURED: 'Microsoft sign-in is not set up on this server.',
    SSO_CANCELLED: 'Microsoft sign-in was cancelled.',
    SSO_INVALID_STATE: 'That sign-in link has expired. Please try again.',
    SSO_TOKEN_EXCHANGE_FAILED: 'Microsoft could not complete the sign-in. Please try again.',
    SSO_INVALID_TOKEN: 'The response from Microsoft could not be verified. Please try again.',
    SSO_UNSUPPORTED_ACCOUNT: 'Personal Microsoft accounts cannot be used. Please sign in with your work account.',
    SSO_NO_EMAIL: 'Your Microsoft account has no email address. Please contact your IT administrator.',
    SSO_DIRECTORY_NOT_MAPPED: 'Your organization is not linked to EGoal. Please contact your administrator.',
    SSO_DISABLED: 'Microsoft sign-in is switched off for your organization.',
    SSO_CONCESSIONAIRE_INACTIVE: 'Your organization is not active. Please contact support.',
    SSO_CONCESSIONAIRE_MISMATCH: 'Your account belongs to a different organization. Please contact your administrator.',
    SSO_DOMAIN_NOT_VERIFIED: 'Your email domain is not verified for your organization. Please contact your administrator.',
    SSO_EMAIL_IN_OTHER_CONCESSIONAIRE: 'That email address is already in use elsewhere. Please contact your administrator.',
    SSO_USER_NOT_PROVISIONED: 'No EGoal account exists for you yet. Please ask your administrator to add you.',
    SSO_NO_STARTING_ROLE: 'Your organization has not set a starting role. Please contact your administrator.',
    SSO_ROLE_NOT_ALLOWED: 'Your role must sign in with a username and password.',
    SSO_USER_DISABLED: 'Your EGoal account is disabled. Please contact your administrator.',
    SSO_INVALID_CODE: 'That sign-in has expired. Please try again.',
    SSO_TOO_MANY_ATTEMPTS: 'Too many failed attempts. Please wait a few minutes and try again.',
    SSO_SERVER_ERROR: 'Something went wrong signing you in. Please try again.'
};

export const messageForSsoError = (code) =>
    SSO_ERROR_MESSAGES[code] || 'Could not sign you in with Microsoft. Please try again.';
